import { render, staticRenderFns } from "./KeyResultFrequency.vue?vue&type=template&id=dbd84846&"
import script from "./KeyResultFrequency.vue?vue&type=script&lang=js&"
export * from "./KeyResultFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports